import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
//import { Table, Input, Button, Space,Select,Tag } from "antd";
import fron from "../../font/Poppins-Regular.ttf";
import moment from "moment";
//  const BORDER_COLOR = '#bfbfbf';
// const BORDER_STYLE = 'solid';
// const COL1_WIDTH = 40;
// const COLN_WIDTH = (100 - COL1_WIDTH) / 3;
Font.register({
  family: "Poppins-Regular",
  src: fron,
});
const styles = StyleSheet.create({
  tbl: {
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 0 0 0",
    padding: 0,
  },
  tableHeader: {
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 0 0 0",
    padding: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    border: "1px solid #f1f1f1",
    backgroundColor: "#f1f1f1",
    // minHeight: 30,
    // maxHeight: 60,
  },
  row: {
    display: "flex",
    flexWrap: "nowrap",
    padding: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    border: "1px solid #f1f1f1",
    // minHeight: 30,
    // maxHeight: 60,
  },
  cell: {
    padding: "5px 5px",
    fontFamily: "Poppins-Regular",
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "100px",
    flexWrap: "wrap",
    width: "100px",
    wordBreak: "break-all",
  },
  firstCell: {
    padding: "5px 5px",
    flexGrow: 1,
    flexShrink: 2,
    fontSize: "9px",
    flexBasis: "160px",
    width: "160px",
    fontFamily: "Poppins-Regular",
  },
  indexCell: {
    padding: "5px 5px",
    flexGrow: 1,
    flexShrink: 1,
    fontSize: "9px",
    flexBasis: "40px",
    wordBreak: "break-all",
    width: "40px",
    fontFamily: "Poppins-Regular",
    backgroundColor: "#f1f1f1",
  },
  imageCell: {
    padding: "5px 5px",
    fontFamily: "Poppins-Regular",
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "100px",
    flexWrap: "wrap",
    width: "100px",
    wordBreak: "break-all",
  },
  header: {
    padding: 15,
    display: "flex",
    marginBottom: 15,
  },
});
// Create Document Component
export const MyDocument = (props) => {
  console.log("props MyDocument", props);
  return (
    <>
      <Document width="1000" height="600">
        <Page size="A4" wrap>
          <View style={styles.header}>
            <Text
              style={{ fontSize: "14px", fontWeight: 600, marginBottom: 8 }}
            >
              (CMIS)-Criminal Report
            </Text>
            <Text style={{ fontSize: "14px" }}>
              Total Records: {props.rows ? props.rows.length : 0}
            </Text>
          </View>
          <View style={styles.tbl}>
            <View style={styles.tableHeader}>
              <Text style={styles.indexCell}>अ.क्र.</Text>
              {props.name && <Text style={styles.firstCell}>नाव</Text>}
              {props.age && <Text style={styles.firstCell}>वय</Text>}
              {props.address && <Text style={styles.firstCell}>पत्ता</Text>}
              {props.mobileNumber && (
                <Text style={styles.firstCell}>फोन नंबर</Text>
              )}
              {props.state_name && <Text style={styles.firstCell}>राज्य</Text>}
              {props.district_name && (
                <Text style={styles.firstCell}>जिल्ह्याचे नाव</Text>
              )}
              {props.city && <Text style={styles.firstCell}>शहर</Text>}
              {props.religion && <Text style={styles.cell}>धर्म</Text>}
              {props.criminal_profile && <Text style={styles.cell}>फोटो</Text>}
              {props.gunhaCount && <Text style={styles.cell}>एकूण गुन्हा</Text>}
            </View>
            {props &&
              props.rows &&
              props.rows.map((item, index) => (
                <View key={index} style={styles.row} wrap={false}>
                  <Text style={styles.indexCell}>{index + 1}</Text>
                  {props.name == true && (
                    <Text
                      fixed={true}
                      style={[styles.firstCell, { wordBreak: "break-all" }]}
                    >
                      {item.name}
                    </Text>
                  )}
                  {props.age == true && (
                    <Text
                      fixed={true}
                      style={[styles.cell, { wordBreak: "break-all" }]}
                    >
                      {item.age}
                    </Text>
                  )}
                  {props.address == true && (
                    <Text style={styles.cell}>{item.address}</Text>
                  )}
                  {props.mobileNumber == true && (
                    <Text style={styles.cell}>
                      {item.mobileNumber ? item.mobileNumber : "नाही"}
                    </Text>
                  )}
                  {props.state_name == true && (
                    <Text style={styles.cell}>{item.state}</Text>
                  )}
                  {props.district_name == true && (
                    <Text style={styles.cell}>{item.districtName}</Text>
                  )}
                  {props.city == true && (
                    <Text style={styles.cell}>{item.city}</Text>
                  )}
                  {props.religion == true && (
                    <Text style={styles.cell}>{item.DharmName}</Text>
                  )}
                  {props.criminal_profile == true && (
                    <Text style={styles.cell}>{item.photo}</Text>
                  )}
                  {props.gunhaCount == true && (
                    <Text style={styles.cell}>{item.gunhaCount}</Text>
                  )}
                </View>
              ))}
          </View>
        </Page>
      </Document>
    </>
  );
};
